import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { CSSTransition } from "react-transition-group";
import { Form, Progress, Alert } from "reactstrap";
import { useLocalization, WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import logo from './img/superplayer-logo.png';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
        cp_convert: parameters.cp_convert
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <Form onSubmit={(event) => onSubmit(event)} className="login-superplayer">
        <div className="wrapper-superplayer fadeInDown" ref={nodeRef}>
          <div id="snackbar"></div>
          <div id="formContent-superplayer">
            <div className="menu1-superplayer">
              <div className="fadeIn first">
              </div>
              <div className="superplayer-logo">
                <img src={logo} alt="superplayer" />
              </div>
              <div><p className="title-superplayer">{translate("Title")}</p></div>
              <div><p className="subtitle-superplayer">{translate("Subtitle")}</p></div>
              <div><p className="detail-superplayer">{translate("UserName")}</p></div>
              <input
                className="fadeIn second"
                disabled={onLogin}
                onChange={e => setUsername(e.target.value)}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                name="login"
                id="login-superplayer"
                placeholder={translate("PlaceholderUserName")}
              />
              <div><p className="detail-superplayer">{translate("Password")}</p></div>
              <input
                className="fadeIn third"
                required={true}
                disabled={onLogin}
                onChange={e => setPassword(e.target.value)}
                tabIndex={1}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                id="password-superplayer"
                name="login"
                placeholder={translate("PlaceholderPassword")}
              >
              </input>
              <div className="buttons-superplayer">
                {!onLogin ? (
                  <button type="submit" className="fadeIn fourth" id="entrar-superplayer" disabled={!props.turnstileSuccess}>
                    <span className="entrar-text" id="text">
                      {translate("ButtonEnter")}
                    </span>
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </div>
              {
                <p className='forgotPass-superplayer'><a href=" https://auth.superplayer.company/sky/forgot-password?company=8bae71ad-d6aa-4b46-90c8-565a4fba4890" target="_blank" rel="noopener noreferrer">{translate('ForgotPassword')}</a></p>}
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </CSSTransition>
  );
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
